import React from 'react';
import { useTranslation } from 'react-i18next';
import { BOOT_LOGO_PATH } from '../config/welcomeAssets';
import './BootLoadingOverlay.css';

function BootLoadingOverlay({ progress, stageKey, dismissed }) {
  const { t } = useTranslation();
  const clampedProgress = Math.max(0, Math.min(1, progress));
  const percent = Math.round(clampedProgress * 100);
  const stageLabel = stageKey ? t(stageKey, { defaultValue: t('boot.loadingAssets') }) : t('boot.loadingAssets');

  return (
    <div
      className={`boot-loading-overlay${dismissed ? ' boot-loading-overlay--dismissed' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy={!dismissed}
      aria-label={t('boot.loadingAssets')}
    >
      <div className="boot-loading-overlay__panel">
        <img
          className="boot-loading-overlay__logo"
          src={BOOT_LOGO_PATH}
          alt={t('welcome.gameTitle')}
        />
        <p className="boot-loading-overlay__title">{t('boot.loadingAssets')}</p>
        <p className="boot-loading-overlay__stage">{stageLabel}</p>
        <div
          className="boot-loading-overlay__track"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
        >
          <div
            className="boot-loading-overlay__fill"
            style={{ width: `${percent}%` }}
          />
        </div>
        <p className="boot-loading-overlay__hint">{t('boot.firstVisitHint')}</p>
      </div>
    </div>
  );
}

export default BootLoadingOverlay;
